import React from 'react'
//import App from '../Flow/src/App.js'

const Programflow = () => {
    return (
        <div style={{ borderTop: "6px solid rgb(34,34,34)",height:"100%"}} className='flow_part'>
            <div style={{height:"100%"}}>
            </div>
        </div>
    )
}

export default Programflow